import React, { FC, useState } from "react";
import { Form, Modal, Button, Alert } from "react-bootstrap";
import { Formik } from "formik";
import * as yup from "yup";
import { UserModel } from "../../../models/UserModel";
import { UserType } from "../../../types/UserType";
import ClipLoader from "react-spinners/ClipLoader";
import { useAuth } from "../../../hooks/useAuth";
import { AuthContext } from "../../../providers/AuthContextProvider";
import { FormattedMessage, useIntl } from "react-intl";
import { LANG_COMMON_CANCEL, LANG_COMMON_CLINIC, LANG_COMMON_NAME, LANG_COMMON_NEW, LANG_COMMON_PASSWORD, LANG_COMMON_PASSWORD_MSG, LANG_COMMON_PROFILE, LANG_COMMON_SAVE, LANG_COMMON_USER, LANG_COMMON_USERS, LANG_ERROR, LANG_LIMIT_ERROR, LANG_WARNING_FILL_ALL } from "../../../lang";
import BusinessSelect from "../../../components/form/BusinessSelect";
import PlanSelect from "../../../components/form/PlanSelect";
import PlanOptionSelect from "../../../components/form/PlanOptionSelect";
import { useAPI } from "../../../hooks/useAPI";

interface Props {
    show: boolean
    onHide: () => void
    onSave: () => void
    plan_id: number
    plan_option_id: number
    subscription_id: number
}
const PlanUpdateModal: FC<Props> = ({ show, onHide, onSave, plan_id, plan_option_id, subscription_id }) => {
    const intl = useIntl();
    const { api } = useAPI();
    const schema = yup.object().shape({
        plan_id: yup.number().required().positive(),
        plan_option_id: yup.number().required().positive(),
    });
    const [formWasSubmitted, setFormWasSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const initialValues = {
        plan_id: plan_id,
        plan_option_id: plan_option_id
    };

    const onSubmit = async (values: any) => {
        setLoading(true);
        setFormWasSubmitted(false);
        api().put(`/api/subscription/${subscription_id}`, {
            plan_id: values.plan_id,
            payment_option_id: values.plan_option_id
        })
            .then((response) => {
                onSave();
            })
            .catch((error) => {
                setHasError(true);
                setErrorMsg(error.response.data.message);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <Modal
            show={show}
            onHide={() => {
                onHide();
                setFormWasSubmitted(false);
            }}
            className="modal-default"
        >
            <Formik
                validationSchema={schema}
                onSubmit={onSubmit}
                initialValues={initialValues}
            >
                {({
                    setFieldValue,
                    handleSubmit,
                    handleChange,
                    values,
                    touched,
                    isValid,
                    errors }) => (
                    <Form noValidate onSubmit={(e) => {
                        setFormWasSubmitted(true);
                        handleSubmit(e);
                    }}>
                        <Modal.Header closeButton closeVariant="white">
                            <Modal.Title>
                                Alterar Plano
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {(!isValid && formWasSubmitted) && (<Alert variant={'danger'}>{intl.formatMessage(LANG_WARNING_FILL_ALL)}</Alert>)}
                            {hasError && (<Alert variant={'danger'}>{errorMsg}</Alert>)}
                            <Form.Group className="mb-3" controlId="business_id">
                                <Form.Label>Plano</Form.Label>
                                <PlanSelect
                                    planId={values.plan_id}
                                    onChange={(plan_id) => {
                                        setFieldValue('plan_id', plan_id);
                                        setFieldValue('plan_option_id', undefined);
                                    }}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="plan_option_id">
                                <Form.Label>Opção de Plano</Form.Label>
                                <PlanOptionSelect
                                    key={values.plan_id}
                                    planId={values.plan_id}
                                    planOptionId={values.plan_option_id}
                                    onChange={(plan_option_id) => {
                                        setFieldValue('plan_option_id', plan_option_id);
                                    }}
                                />
                            </Form.Group>

                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="outline-light" onClick={onHide} className="btn-custom btn-custom-light">
                                {intl.formatMessage(LANG_COMMON_CANCEL)}
                            </Button>
                            <Button variant="primary" type={"submit"} disabled={loading} className="btn-custom bg-custom-gradient">
                                {loading ? <><ClipLoader color={'#ffffff'} loading={loading} size={'12px'} /> </> : intl.formatMessage(LANG_COMMON_SAVE)}
                            </Button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    )
}

export default PlanUpdateModal;